import React from 'react';
import { useLanguage } from './LanguageContext';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { artwork } from './artwork';
export function About() {
  const {
    t
  } = useLanguage();
  return <section id="about" className="py-24 bg-white" data-id="element-18">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-19">
        <div className="grid xl:grid-cols-2 gap-16 items-center" data-id="element-20">
          {/* Image Side */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="relative order-2 xl:order-1" data-id="element-21">
            <div className="relative max-w-md mx-auto" data-id="element-22">
              <div className="aspect-[4/5] rounded-[2rem] overflow-hidden shadow-xl relative border-8 border-teal-50" data-id="element-23">
                <img src="https://cdn.magicpatterns.com/uploads/vqkCKLkfrc7oCahmijs1Q8/05eba-img-20250402-wa0004.jpg" alt="Aissa Edon Portrait" className="object-cover w-full h-full" data-id="element-24" />
              </div>

              {/* Decorative artwork accent */}
              <div className="absolute -bottom-10 -right-6 md:-bottom-8 md:-right-10 w-44 h-44 md:w-48 md:h-48 rounded-full overflow-hidden border-4 border-white shadow-lg z-10" data-id="element-25">
                <img src="https://cdn.magicpatterns.com/uploads/bpQZ1UVPu2jrRBfv6Sstom/WhatsApp_Image_2026-04-12_at_3.08.49_PM.jpg" alt="Mother and Baby Artwork" className="w-full h-full object-cover" data-id="element-26" />
              </div>
            </div>

            {/* Soft background blob */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-teal-50/50 rounded-full -z-10 blur-3xl" data-id="element-27"></div>
          </motion.div>

          {/* Text Side */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="order-1 xl:order-2" data-id="element-28">
            <h2 className="text-3xl sm:text-4xl font-serif font-medium text-teal-900 mb-6" data-id="element-29">
              {t.about.title}
            </h2>

            <div className="space-y-4 text-lg text-slate-600 mb-10 leading-relaxed" data-id="element-30">
              <p data-id="element-31">
                Aïssa Sara Edon is a compassionate French-British midwife based
                in Auckland, offering personalized, culturally sensitive care to
                women and families both locally and through virtual
                consultations worldwide. Her work combines professional
                expertise, warmth, and deep respect for each woman's unique
                journey.
              </p>
              <p data-id="element-32">
                Born in Africa and a survivor of female genital mutilation
                (FGM), Aïssa is also a dedicated activist and advocate for
                women's health. She speaks publicly about her experience to
                raise awareness, break the silence, and help drive lasting
                change for survivors and communities around the world.
              </p>
              <p data-id="element-33">
                With over 16 years of experience supporting families across
                Europe, Africa, and the Middle East, she specializes in
                trauma-informed, compassionate maternity care — particularly for
                first-time mothers, survivors of trauma, and women navigating
                pregnancy and parenthood far from home.
              </p>
              <p data-id="element-34">
                Aïssa is the founder of The FGM Hope Clinic, an organization
                supporting survivors of FGM, and has worked extensively with
                Médecins Sans Frontières (MSF), the NHS, and other international
                healthcare systems. In recognition of her work, she was named
                one of the BBC's 100 Women in 2015 and received the Mary Seacole
                Leadership Scholar Award from the Royal College of Nursing.
              </p>
              <p data-id="element-35">
                Through consultations in English and French, Aïssa offers expert
                support in pregnancy, birth preparation, lactation, postnatal
                care, and women's health advocacy. She combines clinical
                excellence with deep emotional support, because she understands
                how important it is for every woman to feel truly seen, heard,
                and empowered.
              </p>
            </div>

            <div className="bg-teal-50/50 rounded-2xl p-8 border border-teal-100/50" data-id="element-36">
              <h3 className="text-xl font-medium text-teal-800 mb-6" data-id="element-37">
                {t.about.whyWorkTitle}
              </h3>
              <ul className="space-y-4" data-id="element-38">
                {t.about.points.map((point, index) => <motion.li key={index} initial={{
                opacity: 0,
                x: 10
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.5,
                delay: index * 0.1
              }} className="flex items-start space-x-3" data-id="element-39">
                    <CheckCircle2Icon className="text-teal-500 mt-0.5 shrink-0" size={20} data-id="element-40" />
                    <span className="text-slate-700" data-id="element-41">{point}</span>
                  </motion.li>)}
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}